// src\components\ui\shop\topBar.js
// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';

export const TopBar = ({currencyMode, setCurrencyMode, arcanium, votePoints, arcHybrid, arcPvp, arcSaison, server}) => {
  const {t} = useTranslation();

  const selectedArc =
    !server
      ? 0
      : server.toLowerCase() === 'pvp'
      ? arcPvp
      : server.toLowerCase() === 'saison'
      ? arcSaison
      : arcHybrid;
  const serverLabel = server ? server.toUpperCase() : 'SERVER';

  return (
    <BarContainer>
      <LeftButtons>
        <ToggleButton active={currencyMode === 'arcanium'} onClick={() => setCurrencyMode('arcanium')}>
          {t('topBar.cashShop')}
        </ToggleButton>
        <ToggleButton active={currencyMode === 'votePoints'} onClick={() => setCurrencyMode('votePoints')}>
          {t('topBar.voteShop')}
        </ToggleButton>
      </LeftButtons>
      <RightGroup>
        <RightInfo>
          <BalanceDisplay>
            {'Arc ' + serverLabel}: {selectedArc}
          </BalanceDisplay>
        </RightInfo>
        <RightInfo>
          <BalanceDisplay>
            {t('topBar.arcanium')}: {arcanium}
          </BalanceDisplay>
          <BalanceDisplay>
            {t('topBar.votePoints')}: {votePoints}
          </BalanceDisplay>
        </RightInfo>
      </RightGroup>
    </BarContainer>
  );
};

const BarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 10px;
  background-image: url(/assets/ui/container-big-bg.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LeftButtons = styled.div`
  display: flex;
  gap: 8px;
`;

const ToggleButton = styled.button`
  padding: 8px 12px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  ${({active}) =>
    active &&
    `
    color: black;
  `}

  @media (max-width: 768px) {
    width: 110px;
  }
`;

const RightInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  margin-top: 7px;
  margin-right: 15px;

  @media (max-width: 768px) {
    align-items: center;
    margin-top: 10px;
    margin-right: 0;
  }
`;

const RightGroup = styled.div`
  margin-left: auto; /* schiebt die Gruppe nach ganz rechts */
  display: flex;
  gap: 28px; /* -> hier „bisschen weiter rechts“ feinjustieren */
  align-items: flex-start;
`;

const BalanceDisplay = styled.div`
  font-size: 1rem;
`;
